import Url from 'domurl';
import {Fields} from '../search/fields';
import {searchForm} from '../search/search_form';

var modalContainer;
var modalContent;
var viewListingsButton;

var count;
var filter;
var expressions;
var closeCallback;
var filterUrl;

function show(_filterUrl, _closeCallback) {

  filterUrl = new Url(_filterUrl);
  closeCallback = (typeof _closeCallback === 'function') ? _closeCallback : function(){};

  modalContainer = $('#filterModal');
  modalContent = modalContainer.find('#filterModalContent');
  viewListingsButton = modalContainer.find('#viewListingsButton');
  
  modalContainer.on('shown.bs.modal', startLoadingMode);
  loadForm();

  modalContainer.modal();

  bindButtons();

  window.addEventListener('searchForm:fieldsReloading', startLoadingMode);

  window.addEventListener('searchForm:fieldsReloaded', function(e) {
    stopLoadingMode();
    updateData(e.detail);
  });

  window.addEventListener('searchForm:countChanged', function(e) {
    updateData(e.detail);
  });
    
}

function loadForm() {
  startLoadingMode();
  $.ajax({
    url: filterUrl,
    success: function(data) {
      updateData( data );
      modalContent.html(data.fields + data.add_field);
      searchForm.init(data.existing_locations);
    },
    complete: stopLoadingMode
  });
}

function bindButtons() {
  viewListingsButton.unbind('click', handleViewListingsClick).click(handleViewListingsClick);
  $('#resetFiltersLink').unbind('click', handleResetFiltersClick).click(handleResetFiltersClick);
}

function handleViewListingsClick(e) {
  e.preventDefault();
  modalContainer.modal('hide');
  closeCallback(count, expressions);
}

function handleResetFiltersClick(e) {
  e.preventDefault();
  delete(filterUrl.query._filter);
  loadForm();
}

function updateData(data){
  if(typeof data.filter !== 'undefined') {
    filter = data.filter;
  }
  if(typeof data.message !== 'undefined') {
    viewListingsButton.text(data.message);
  }
  if(typeof data.expressions !== 'undefined') {
    expressions = data.expressions;
  }
  if(typeof data.count !== 'undefined') {
    count = data.count;
  }
}

function startLoadingMode(e) {
  showPageLoadingMsg({target: modalContainer.find('.c-modal')});
  modalContainer.addClass('filter-form-loading');
}

function stopLoadingMode() {
  modalContainer.removeClass('filter-form-loading');
  hidePageLoadingMsg();
}

export let filterModal = {
  show: show
};
